import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ObjAssocIconMobile.module.css';
import ImageWithFallback from '../GenericComponents/ImageWithFallback';
import { getImages } from '../Result/getImages';

interface RecordIconProps {
    record: any;
    index: number;
    handleLinkClick: (event: React.MouseEvent, index: number) => void;
}

const ObjAssocIcon: React.FC<RecordIconProps> = ({ record, index, handleLinkClick }) => {
    const { t } = useTranslation();
    const [isHovered, setIsHovered] = useState(false);
    //const imageUrl = `cc/imageproxy.ashx?server=localhost&port=15012&filename=${record?.data?.Record?.Image?.Image ?? 'noimage.cci'}&maxwidth=240&maxheight=160&borderwidth=0&borderheight=0&bordercolor=e8e8e8&bg=ffffff&passepartoutwidth=0&passepartoutheight=0&passepartoutcolor=f8f8f8&cache=yes`;
    let filename = '';
    if (record?.data?.Record?.source === "icono") {
        if (record?.data?.Record?.IImages?.image2) {
            filename = record.data.Record.IImages.image2;
        }
    } else {
        if (record?.data?.Record?.Image?.image2) {
            filename = record.data.Record.Image.image2;
        }
    }

    const allImages = getImages(record);
    const imageUrl = (allImages as any)["icon"][0]?.url;

    const invNo = record?.data?.Record?.ObjectNumber ? record?.data?.Record?.ObjectNumber : record?.data?.Record?.ObjectNumber2; //should be searchnumber

    console.log('assoc invo', invNo);

    function getObjectTitle(record: any) {
        const titleData = record?.data?.Record?.Title;

        if (!titleData) return <div className={styles.row}>Pas de titre</div>;

        const title = titleData.Title;
        const titleType = titleData.TitleType;

        if (!title) return <div className={styles.row}>Pas de titre</div>;

        return (
            <div className={styles.row}>
                {titleType ? (
                    <>
                        <span className={styles.taglabel}>{titleType} :</span> {title}
                    </>
                ) : title}
            </div>
        );
    }

    function getIconoTitle(record: any) {
        const titleData = record?.data?.Record?.Title;

        if (!titleData) return <div className={styles.row}>Pas de titre</div>;

        const title = titleData.Title;
        const titleType = "Historical title";

        if (!title) return <div className={styles.row}>Pas de titre</div>;

        return (
            <div className={styles.row}>
                {titleType ? (
                    <>
                        <span className={styles.taglabel}>{t(titleType)} :</span> {title}
                    </>
                ) : title}
            </div>
        );
    }

    return (
        <a
            href={`${window.location.pathname}?action=search&field=/Record/ObjectNumber&label=N°%20de%20gestion&value=[${invNo}]`}
            className={styles.ObjAssocIcon}
            key={index}
            onClick={(event) => handleLinkClick(event, index)}
            onMouseDown={e => e.preventDefault()}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div className={styles.iconViewRecord}>
                {imageUrl && <ImageWithFallback src={imageUrl} alt="Image" height={100} placeholder="cc/imageproxy.ashx?server=localhost&port=15012&filename=pas-dimage-white.png&width=140&height=100&borderwidth=0&borderheight=0&bordercolor=000000&bg=ffffff&passepartoutwidth=0&passepartoutheight=0&passepartoutcolor=ff6666&cache=yes" />}
                {isHovered && (
                    <div className={styles.hoverOverlay}>
                        <div className={styles.title}>{record?.data?.Record?.recordtype === "objets" ? getObjectTitle(record) : getIconoTitle(record)}</div>
                        {record?.data?.Record?.Country && <div className={styles.staticText}>Pays</div>}
                        {record?.data?.Record?.source === "objects" ? (Array.isArray(record?.data?.Record?.Country)
                            ? record?.data?.Record?.Country[0]?.Term ?? t('No country')
                            : record?.data?.Record?.Country?.Term ?? t('No country')
                        ) : (Array.isArray(record?.data?.Record?.Country)
                            ? record?.data?.Record?.Country[0]?.Term ?? t('No country')
                            : record?.data?.Record?.Country?.Term ?? t('No country')
                        )
                        }
                    </div>
                )}
            </div>
        </a>
    );
};

export default ObjAssocIcon;
